<template>
  <div>
    <template v-if="!readonly">
      <v-card :id="`editor-js${index}`" style="padding: 15px 40px; margin-left: 30px;"> </v-card>
      <div class="text-xs-right">
        <v-btn outline @click="saveEditor">{{ $t('Save') }}</v-btn>
      </div>
    </template>
    <template v-else>
      <div>
        <div :id="`editor-js${index}`"></div>
      </div>
    </template>
  </div>
</template>

<script>
import EditorJS from '@editorjs/editorjs'
import Paragraph from 'editorjs-paragraph-with-alignment'
import ColorPlugin from 'editorjs-text-color-plugin'
import Embed from '@editorjs/embed'
import FontSize from 'editorjs-inline-font-size-tool'
import Table from '@editorjs/table'
import NestedList from '@editorjs/nested-list'
export default {
  props: ['value', 'index', 'readonly'],
  computed: {
    setValue() {
      return this.value
    }
  },
  data() {
    return {
      editor: null
    }
  },
  methods: {
    saveEditor() {
      var vm = this
      this.editor
        .save()
        .then(savedData => {
          vm.$emit('input', savedData)
          vm.$emit('resetShowPreview')
        })
        .catch(error => {
          console.log('Saving failed: ', error)
        })
    },
    Editor: function() {
      var vm = this
      this.editor = new EditorJS({
        holder: `editor-js${this.index}`,
        autofocus: !this.readonly,
        readOnly: this.readonly,
        /**
         * This Tool will be used as default
         */
        initialBlock: 'paragraph',
        tools: {
          fontSize: FontSize,
          table: {
            class: Table
          },
          list: {
            class: NestedList,
            inlineToolbar: true
          },
          embed: {
            class: Embed,
            config: {
              services: {
                youtube: true,
                coub: true,
                caption: false
              }
            }
          },
          Color: {
            class: ColorPlugin, // if load from CDN, please try: window.ColorPlugin
            config: {
              colorCollections: [
                '#FF1300',
                '#EC7878',
                '#9C27B0',
                '#673AB7',
                '#3F51B5',
                '#0070FF',
                '#03A9F4',
                '#00BCD4',
                '#4CAF50',
                '#8BC34A',
                '#CDDC39',
                '#FFF',
                '#000000',
                '42210B',
                '#ED1E79',
                '#B01B5D',
                '#FFBE01',
                '#FF015D',
                '#FF6868',
                '#FF9898',
                '#F7D9B5',
                '#FFD8A4',
                '#FD1268',
                '#FF811E'
              ],
              defaultColor: '#FF1300',
              type: 'text'
            }
          },
          Marker: {
            class: ColorPlugin, // if load from CDN, please try: window.ColorPlugin
            config: {
              defaultColor: '#FFBF00',
              type: 'marker'
            }
          },

          paragraph: {
            class: Paragraph,
            inlineToolbar: true
          }
        },
        data: vm.setValue
      })
    }
  },
  created: function() {
    this.Editor()
  }
}
</script>

<style lang="css" scoped>
.editorx_body {
  /* width: 62%;
  margin-left: 15%; */
  width: 60%;
  margin-left: 20%;
  border: 2px solid #f1f3f5;
  box-sizing: border-box;
}
.ce-block--focused {
  background: linear-gradient(
    90deg,
    rgba(2, 0, 36, 1) 0%,
    rgba(9, 9, 121, 0.5438550420168067) 35%,
    rgba(0, 212, 255, 1) 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/salePage/templateType/Message.vue